import { useTheme } from 'next-themes';

/** React Flow's own colour mode, kept in step with the console theme. */
export function useFlowColorMode(): 'light' | 'dark' {
  const { resolvedTheme } = useTheme();
  return resolvedTheme === 'dark' ? 'dark' : 'light';
}
